import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueMobileDetection from 'vue-mobile-detection'
import VueCryptojs from 'vue-cryptojs'
import { useInterceptor } from "@/api/login.api"

import './assets/scss/custom.scss'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueMobileDetection)
Vue.use(VueCryptojs)

new Vue({
    router,
    store,
    i18n,
    
    created() {

        // Check if login info is in local storage
        const l_login = localStorage.getItem('logged')
        const l_solicitante = localStorage.getItem('solicitante')

        if(l_login && l_solicitante) {

            const login = JSON.parse(l_login)
            this.$store.commit('Login/SET_LOGIN', login)

            this.$store.commit('Login/SET_SOLICITANTE', l_solicitante)

            useInterceptor(login.token)

            this.$router.push(`/${this.$i18n.locale}/home`)

        }

    },
    
    render: h => h(App)
}).$mount('#app')
